// CUI-ul firmelor clientilor (doar firme — docs/16 §18). Aceeasi regula ca
// private.normalize_cui / private.is_valid_cui din platform/supabase/migrations
// (20261031100000_fundatie.sql); vectorii de test sunt aceiasi in ambele parti.

const CUI_KEY = '753217532';

export function normalizeCui(value: string): string {
  return value
    .toUpperCase()
    .replace(/^\s*RO/, '')
    .replace(/[^0-9]/g, '');
}

export function isValidCui(value: string): boolean {
  const cui = normalizeCui(value);
  if (cui.length < 2 || cui.length > 10) return false;
  const body = cui.slice(0, -1).padStart(9, '0');
  let sum = 0;
  for (let i = 0; i < 9; i++) sum += Number(body[i]) * Number(CUI_KEY[i]);
  const control = (sum * 10) % 11;
  return (control === 10 ? 0 : control) === Number(cui.at(-1));
}
